import { z } from 'zod';
// Generic API error schema
export const ApiErrorSchema = z.object({
    error: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
    code: z.string().optional(),
});
// Booking response schema
export const BookingResponseSchema = z.object({
    success: z.boolean(),
    appointmentId: z.string().uuid().optional(),
    error: z.string().optional(),
    message: z.string().optional(),
});
// Tenant lookup response schema
export const TenantResponseSchema = z.object({
    tenant: z.object({
        id: z.string().uuid(),
        name: z.string(),
        slug: z.string(),
        primary_color: z.string().nullable().optional(),
        logo_url: z.string().nullable().optional(),
        website_url: z.string().nullable().optional(),
        phone: z.string().nullable().optional(),
        settings: z.record(z.string(), z.unknown()).optional(),
    }).optional(),
    error: z.string().optional(),
});
// Available services response schema
export const ServicesResponseSchema = z.object({
    services: z.array(z.object({
        id: z.string().uuid(),
        name: z.string(),
        description: z.string().optional(),
        duration_minutes: z.number(),
        price: z.number().optional(),
        is_active: z.boolean(),
        color: z.string().optional(),
    })),
    error: z.string().optional(),
});
// Available team members response schema
export const TeamMembersResponseSchema = z.object({
    teamMembers: z.array(z.object({
        id: z.string().uuid(),
        name: z.string(),
        title: z.string().optional(),
        bio: z.string().optional(),
        avatar_url: z.string().optional(),
        is_active: z.boolean(),
    })),
    error: z.string().optional(),
});
// Generic success response schema
export const SuccessResponseSchema = z.object({
    success: z.boolean(),
    message: z.string().optional(),
    data: z.unknown().optional(),
});
